import request from '@/utils/request'

/** 商户列表 */
export function getMerchantList(joinStatus, keyword, page = 1, size = 10) {
  return request({
    url: '/manage/merchant/list',
    method: 'post',
    params: { joinStatus, keyword, page, size }
  })
}

/** 修改商户信息 */
export function updateMerchant(merchantId, data) {
  return request({
    url: `/manage/merchant/updateMerchant/${merchantId}`,
    method: 'post',
    data
  })
}

/** 商户列表 */
export function getMerchantNameList() {
  return request({
    url: '/manage/merchant/merchantNameList',
    method: 'post',
  })
}

/** 商户详情 */
export function getMerchantDetail(id) {
  return request({
    url: `/manage/merchant/detail/${id}`,
    method: 'post'
  })
}

/** 审核通过 */
export function approveMerchant(id, remark) {
  return request({
    url: `/manage/merchant/approve/${id}`,
    method: 'post',
    data: { remark }
  })
}

/** 审核驳回 */
export function rejectMerchant(id, reason) {
  return request({
    url: `/manage/merchant/reject/${id}`,
    method: 'post',
    data: { reason }
  })
}

/** 启用/禁用 */
export function toggleMerchant(id) {
  return request({
    url: `/manage/merchant/toggle/${id}`,
    method: 'post'
  })
}


/** 工作人员列表 */
export function getStaffList(merchantId, page = 1, size = 10) {
  return request({
    url: '/manage/merchant/staff/list',
    method: 'post',
    params: { merchantId, page, size }
  })
}

/** 新增工作人员 */
export function addStaff(data) {
  return request({
    url: '/manage/merchant/staff/add',
    method: 'post',
    data
  })
}

/** 修改工作人员 */
export function updateStaff(data) {
  return request({
    url: '/manage/merchant/staff/update',
    method: 'post',
    data
  })
}

/** 启用/禁用工作人员 */
export function toggleStaff(id) {
  return request({
    url: `/manage/merchant/staff/toggle/${id}`,
    method: 'post'
  })
}

/** 重置密码 */
export function resetStaffPwd(id, newPwd) {
  return request({
    url: `/manage/merchant/staff/reset-pwd/${id}`,
    method: 'post',
    data: { newPwd }
  })
}

/** 修改商户信息 */
export function saveMerchantClaimConfig(merchantId, data) {
  return request({
    url: `/manage/merchant/updateMerchantClaimConfig/${merchantId}`,
    method: 'post',
    data
  })
}
